import { Link } from './link';

export * from './link';
export * from './types';

export default Link;
